export const API_URL = '/Dr_MJtladi_test/api';
